// Rails core
import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

// Analytics: UTM capture, download click tracking, scroll depth
import "../sections/analytics";

// Styles
import "stylesheets/application.scss";
import "stylesheets/cookie_consent.scss";
import "stylesheets/footer.scss";
import "stylesheets/styles_september_25.scss";


// jQuery FIRST — make global
import $ from "jquery";
window.$ = window.jQuery = $;

// Owl Carousel plugin + CSS
import "owl.carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Your controllers (AFTER jQuery is global)
import "../controllers/modal";
import "../controllers/nav";
import "../controllers/owl_init";
import "../controllers/slide-out";
import "../controllers/cookie_consent_controller";
import "../controllers/promotions_controller";
import { bindAccordionOnce } from "../controllers/accordion";
bindAccordionOnce(); // no DOMContentLoaded needed thanks to delegation

import "./nav_header";
import "../sections/stintercards";
import "../sections/reviewcards";
import "../sections/workforce_index_hero";
import "../sections/workforce_index_section_1";
import "../sections/workforce_index_section_2";
import "../sections/workforce_index_section_3";
import "../sections/workforce_index_section_4";

// application.js
import { initReferences } from "../sections/workforce_index_references";
document.addEventListener("DOMContentLoaded", initReferences);

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("workforce")) {
        import("../sections/workforce").then(({ initWorkforce }) => initWorkforce());
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("stratos-section")) {
        import("../sections/stratos").then(({ initStratos }) => initStratos());
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("references-partners")) {
        import("../sections/references").then(({ initReferences }) => initReferences());
    }
});

// Stinter page – generic reveal-on-scroll animations
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".stinter-reveal")) {
        import("../sections/stinter_reveal").then(({ initStinterReveal }) => initStinterReveal());
    }
});

// Stinter page – reviews carousel (mobile only behaviour, dots indicator)
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".reviews-carousel")) {
        import("../sections/reviews_carousel").then(({ initReviewsCarousel }) => initReviewsCarousel());
    }
});

// Stinter page – stinter card video modal (map section)
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".stinter-card-btn")) {
        import("../sections/stinter_card_videos").then(({ initStinterCardVideos }) => initStinterCardVideos());
    }
});

document.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById("cta-section")) {
        import("../sections/cta").then(({ initCTA }) => initCTA());
    }
});

// Images (if used)
const images = require.context('../images', true);



Rails.start();
ActiveStorage.start();